import { GroupCodesController } from '@/components/controls';
import { Fragment, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

export function SharedMissingPersonEditorDialog({
  share,
  isOpen,
  onClose,
  onDelete,
}) {
  const { control, handleSubmit, reset } = useForm({
    defaultValues: share,
  });

  useEffect(() => {
    reset(share);
  }, [reset, share, isOpen]);

  function handleClose() {
    onClose();
  }

  return (
    <form id="missing-share-editor-form" onSubmit={handleSubmit(onClose)}>
      <Dialog open={isOpen} onClose={handleClose}>
        <DialogTitle>{share?.code ? 'Update share' : 'Share'}</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <DialogContentText>
              Please select the groups you wish to share this missing person
              with and provide a reason.
            </DialogContentText>
            <GroupCodesController
              label="Groups"
              control={control}
              name="groupCodes"
              rules={{ required: 'Required' }}
              types={['SECTOR', 'TEAM']}
            />

            <Controller
              name="reason"
              control={control}
              rules={{ required: 'Required' }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  size="small"
                  label="Reason"
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          {!!share?.code && (
            <Fragment>
              <Button color="error" onClick={onDelete}>
                Delete
              </Button>
              <Box sx={{ flexGrow: 1 }} />
            </Fragment>
          )}
          <Button onClick={handleClose}>Cancel</Button>
          <Button form="missing-share-editor-form" type="submit">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  );
}
